import type { TabNavItem } from '@mercedes-benz/odp-theme-v2';
import { GeoFormsIcon, RelationsIcon } from '@mercedes-benz/odp-theme-v2';
import { RELATION_HAS_PART } from '@backstage/catalog-model';
import InfoIcon from '@mui/icons-material/Info';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { EntityPageLayout } from './EntityPageLayout';
import { CoreDetailsTab } from '../system-details/CoreDetailsTab';
import { RelationsTab } from '../system-details/RelationsTab';
import { RelatedEntitiesTab } from './RelatedEntitiesTab';
import { DiagramTab } from './DiagramTab';

const TABS: TabNavItem[] = [
  { id: 'overview', label: 'Overview', icon: InfoIcon },
  { id: 'systems', label: 'Systems', icon: GeoFormsIcon },
  { id: 'diagram', label: 'Diagram', icon: AccountTreeIcon },
  { id: 'relations', label: 'Relations', icon: RelationsIcon },
];

export const DomainEntityPage = () => (
  <EntityPageLayout tabs={TABS}>
    {activeTab => (
      <>
        {activeTab === 'overview' && <CoreDetailsTab />}
        {activeTab === 'systems' && (
          <RelatedEntitiesTab
            relationType={RELATION_HAS_PART}
            kindFilter="system"
            title="Systems"
          />
        )}
        {activeTab === 'diagram' && <DiagramTab />}
        {activeTab === 'relations' && <RelationsTab />}
      </>
    )}
  </EntityPageLayout>
);
